import React, {Component} from 'react';
import BannerChar from './BannerChar';
import {Droppable} from 'react-beautiful-dnd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {faArrowUp, faArrowDown} from '@fortawesome/pro-light-svg-icons';

import {CHAR_BANK_ID, CHAR_BANK_2_ID} from '../constants';

class CharBank extends Component {
  state = {
    isContextMenuVisible: false,
    anchorEl: null,
    contextMenuModel: null,
  };

  renderChar = (model, index, maxHeight, boxes) => {
    const {charWidth} = this.props;

    return (
      <div key={model.uuid} onContextMenu={(event) => this.handleRightClick(event, model)}>
        <BannerChar index={index} model={model} extraStyle={{width: charWidth, maxHeight}} boxes={boxes} />
      </div>
    );
  };

  handleRightClick = (event, model) => {
    const {hasElkoninBox} = this.props;

    // Only show context menu when both char banks are present
    if (!hasElkoninBox) {
      this.setState({anchorEl: event.currentTarget, isContextMenuVisible: true, contextMenuModel: model});
      event.preventDefault();
    }
  };

  handleCloseContextmenu = () => {
    this.setState({isContextMenuVisible: false, anchorEl: null, contextMenuModel: null});
  };

  handleSwitchCharBank = (direction) => {
    const {switchCharBank} = this.props;
    const {contextMenuModel} = this.state;

    if (direction === 'UP') switchCharBank(contextMenuModel, CHAR_BANK_ID, CHAR_BANK_2_ID);
    else if (direction === 'DOWN') switchCharBank(contextMenuModel, CHAR_BANK_2_ID, CHAR_BANK_ID);

    this.handleCloseContextmenu();
  };

  renderContextMenu = () => {
    const {box} = this.props;
    const isMoveUpVisible = box.uuid === CHAR_BANK_ID;
    const isMoveDownVisible = box.uuid === CHAR_BANK_2_ID;

    return (
      <Menu
        anchorEl={this.state.anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'center',
        }}
        getContentAnchorEl={null}
        open={this.state.isContextMenuVisible}
        onClose={this.handleCloseContextmenu}
      >
        {isMoveUpVisible && (
          <MenuItem onClick={() => this.handleSwitchCharBank('UP')}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faArrowUp} />
            </ListItemIcon>
            <ListItemText primary="Move Up" />
          </MenuItem>
        )}
        {isMoveDownVisible && (
          <MenuItem onClick={() => this.handleSwitchCharBank('DOWN')}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faArrowDown} />
            </ListItemIcon>
            <ListItemText primary="Move Down" />
          </MenuItem>
        )}
      </Menu>
    );
  };

  render() {
    const {box, beingDragged, height, boxes} = this.props;
    const justify = box.uuid === CHAR_BANK_2_ID ? 'center' : 'normal';
    const marginBottom = box.uuid === CHAR_BANK_2_ID ? 0 : '3%'; // Raise bottom char bank over whiteboard marker tray

    return (
      <>
        {this.renderContextMenu()}

        <Droppable
          droppableId={box.uuid}
          direction="horizontal"
          isDropDisabled={['all-elkonin-boxes', 'clipart'].includes(beingDragged?.source?.droppableId)}
        >
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="designer-char-bank"
              style={{height, marginBottom, justifyContent: justify}}
            >
              {box.items.map((char, index) => this.renderChar(char, index, height, boxes))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </>
    );
  }
}

export default CharBank;
